'use client'

import Link from 'next/link'

import { cn } from '@/_lib/utils'
import { IPriceListPromotion } from '@/_types'

import ADiscountCard from './a-discount-card'

const ADiscountsSection = ({
	priceListPromotions,
	className,
	showAllButton = false
}: {
	priceListPromotions: IPriceListPromotion[]
	className?: string
	showAllButton?: boolean
}) => {
	return (
		<div
			className={cn(
				'grid grid-cols-1 lg:grid-cols-2 gap-3 max-w-6xl mx-auto [&_a]:min-w-0',
				className
			)}
		>
			{priceListPromotions.map(priceListPromotion => (
				<ADiscountCard
					key={priceListPromotion.id}
					priceListPromotion={priceListPromotion}
				/>
			))}

			{showAllButton && (
				<div className='col-span-full mt-4'>
					<div className='flex justify-center items-center mt-2'>
						<Link href='/akciova-ponuka#akcie' className='btn_basic cyclamen'>
							<span className='px-3!'>Zobraziť všetky akcie</span>
						</Link>
					</div>
				</div>
			)}
		</div>
	)
}

export default ADiscountsSection
